export const TEACHABLE_URL = "https://www.algoseacow.com"
export const TASK_URL = `https://task${process.env.NODE_ENV !== "production" ? "-dev" : ""}.algoseacow.com`
export const PORTAL_URL = `https://portal${process.env.NODE_ENV !== "production" ? "-dev" : ""}.algoseacow.com`
export const JUDGE_URL = "https://judge.algoseacow.com"
export const FACEBOOK_URL = "https://www.facebook.com/algo.seacow"
export const APCSMOCK_URL = "https://apcs-mock.algoseacow.com"

export const REDIRECT_PREVIEW = {
  [TASK_URL]: '題單系統'
};